import React, { useMemo } from 'react'
import { useNewTranslation } from 'hooks/index'
import { useSelector } from 'react-redux'
import { Box } from 'rebass'
import _ from 'lodash'
import { selectSelectedSubmissionView, makeShowLinkInBioSelector, SubmissionProgressProps } from 'state/review'
import { SUBMISSION_VIEW_ENUM } from 'state/submissions'
import { theme } from 'theme'
import { State } from 'state'
import { StepState, TaskState } from 'state/tasks'
import TextField from 'particles/TextInputs/TextField'

interface LinkInBioProps {
    submissionProgress: SubmissionProgressProps
    step: StepState
    task: TaskState
}

const LinkInBio: React.FC<LinkInBioProps> = ({ submissionProgress, step, task }) => {
    const [newT] = useNewTranslation()
    const selectedSubmissionView = useSelector(selectSelectedSubmissionView)
    const selectShowLinkInBio = useMemo(makeShowLinkInBioSelector, [])
    const showLinkInBio = useSelector((state: State) => selectShowLinkInBio(state, { step, task }))

    if (!step || !task || !showLinkInBio) {
        return null
    }

    const isStaticLinkInBioType = task && task.data && task.data.link_in_bio_type === 1

    let linkInBioUrl
    if (isStaticLinkInBioType) {
        linkInBioUrl = task.data['link_in_bio_url']
    } else if (
        task &&
        task.data &&
        task.data.link_in_bio_type === 2 &&
        submissionProgress &&
        submissionProgress.submission_task != undefined
    ) {
        linkInBioUrl = submissionProgress.submission_task.data['link_in_bio_url']
    }

    const showLinkInBioComp =
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.FOR_REVIEW
            ? isStaticLinkInBioType
                ? showLinkInBio && !_.isEmpty(linkInBioUrl) && linkInBioUrl.length > 0
                : showLinkInBio &&
                  submissionProgress &&
                  submissionProgress.pending_action &&
                  submissionProgress.pending_action.data &&
                  submissionProgress.pending_action.data.data &&
                  submissionProgress.pending_action.data.data['link_in_bio_url'] !== null &&
                  submissionProgress.pending_action.data.data['link_in_bio_url'].length > 0
            : showLinkInBio && !_.isEmpty(linkInBioUrl) && linkInBioUrl.length > 0

    return showLinkInBioComp ? (
        <Box pb={theme.spacing.xxs}>
            <TextField
                width={'100%'}
                name={'linkInBioField'}
                size={'s'}
                subtext={newT('submission.review.linkInBioHeader', 'Link in bio')}
                value={
                    selectedSubmissionView == SUBMISSION_VIEW_ENUM.FOR_REVIEW
                        ? isStaticLinkInBioType
                            ? linkInBioUrl
                            : submissionProgress.pending_action.data.data['link_in_bio_url']
                        : linkInBioUrl
                }
                isReadOnly={true}
            />
        </Box>
    ) : null
}

export default LinkInBio
